import React, {Component} from "react";
import logoWhite from '../assets/images/logo-white.png';
import homeBackgroundImage from '../assets/images/home-bg.jpg';
import config from "../config";
import {Link} from "react-router-dom";
import {withStyles} from '@material-ui/core/styles';
import {Helmet} from "react-helmet";
import {metaDescriptions, metaImages, metaTitles, title} from "../website-utils/meta";
import ScrollToTopOnMount from "../website-utils/ScrollToTopOnMount";


class HomePage extends Component {
  componentDidMount() {
    window.analytics.page("Home");
  }

  render() {
    const {classes} = this.props;

    window.prerenderReady = true;

    return (
      <React.Fragment>
        <div className={`singleshift home ${classes.content}`} style={{backgroundImage: `url(${homeBackgroundImage})`}}>
          <Helmet>
            {title('SingleShift')}
            {metaTitles('SingleShift')}
            {metaDescriptions('We help restaurants and caterers fill staffing gaps with our marketplace of vetted and experienced culinary professionals.')}
            {metaImages(`${window.location.origin}${homeBackgroundImage}`)}
          </Helmet>
          <ScrollToTopOnMount/>
          <div className={`container ${classes.container}`}>
            <div className="row justify-content-md-center">
              <div className="col-md-6 text-center">
                <img className={`logo ${classes.logo}`} src={logoWhite}/>
                <h1 className={classes.message}>Making food and beverage life easier.</h1>
                <div className={classes.brief}>
                  <p>SingleShift helps food and beverage businesses fill shifts with our
                    marketplace of experienced
                    professionals.</p>
                </div>
              </div>
            </div>
            <div className={`${classes.callToActions} row`}>
              <div className="col-md-3">
                <div className={classes.button}>
                  <Link to={config.routes.business}>
                    <button type="button" className={`${classes.btnXlg} btn btn-primary btn-xlg btn-block btn-pointer`}>Looking for staff</button>
                  </Link>
                </div>
              </div>
              <div className="col-md-3">
                <div className={classes.button}>
                  <Link to={config.routes.pros}>
                    <button type="button" className={`${classes.btnXlg} btn btn-primary btn-xlg btn-block btn-pointer`}>Looking for work</button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const styles = (theme) => ({
  content: {
    minHeight: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'stretch',
  },
  container: {
    [theme.breakpoints.up('md')]: {
      position: 'relative',
      top: '-10vh',
    }
  },
  logo: {
    marginBottom: theme.spacing.unit * 4,
  },
  message: {
    color: 'white',
    fontWeight: 'bold',
    marginBottom: theme.spacing.unit * 2,
  },
  brief: {
    marginBottom: theme.spacing.unit * 5,
    '& p': {
      color: 'white'
    },
  },
  callToActions: {
    margin: '0 auto',
    textAlign: 'center',
    [theme.breakpoints.up('md')]: {
      display: 'flex',
      justifyContent: 'center',
    }
  },
  btnXlg: {
    padding: '15px 0 !important',
    marginBottom: '15px',
  },
});

export default withStyles(styles)(HomePage);



// WEBPACK FOOTER //
// ./src/pages/HomePage.js